var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48591 5.88858C6.10935 5.39606 6.83506 4.94764 7.69701 4.60515C11.592 3.05748 16.0007 4.95889 17.5484 8.85393C19.0993 12.7571 17.1979 17.1658 13.3029 18.7135C9.40783 20.2611 4.99913 18.3597 3.45146 14.4647C2.87633 13.0173 2.77909 11.4929 3.08131 10.0735",
    stroke: "#9AA4B8",
    strokeWidth: 1.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4553 6.30417L5.5943 2.625",
    stroke: "#9AA4B8",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4552 6.30415L8.02232 7.08131",
    stroke: "#9AA4B8",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7462 14.5949L11.0337 12.9762C10.5612 12.6962 10.1762 12.0224 10.1762 11.4712V7.88367",
    stroke: "#9AA4B8",
    strokeWidth: 1.61538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLogo);
export default __webpack_public_path__ + "static/media/history_logo.e94ba4447be73966f8ee264454f9a803.svg";
export { ForwardRef as ReactComponent };